var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgFigureskating({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 50,
    height: 50,
    viewBox: "0 0 50 50",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd",
    transform: "translate(0 5)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#639AEB",
    d: "M3.893 30.407c3.264 1.435 6.7 1.344 10.546 1.344 3.844 0 5.986.475 9.822 1.486l2.893.785c7.416 2.002 11.384 1.787 17.54-.842l1.095.91c-6.273 3.108-10.636 3.289-17.889 1.453l-3.942-1.06c-3.578-.943-5.623-1.3-8.059-1.304l-.468.001 0 3.587-10.272 0-1.266-6.36Z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#000",
    d: "M32.93 35.206c4.155.484 7.413-.168 11.764-2.026l1.095.91c-6.273 3.108-10.636 3.289-17.889 1.453 2.581.303 4.258.191 5.03-.337Z",
    opacity: 0.304
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#83B3F9",
    d: "M5.011 20.893c4.746 0 8.618 3.79 8.719 8.517l-.007-.129-3.027-.097-1.042-.044c-1.496-.076-2.696-.2-3.639-.478-2.627-.772-3.247-2.593-2.632-5.69.214-.68.418-1.36.61-2.045l.668-.027c.116-.004.233-.007.35-.007Z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#83B3F9",
    d: "M11.834 4.25c.384 4.539 3.246 10.033 7.735 14.676 7.234 7.48 16.673 10.709 21.15 6.39.44-.423.813-.907 1.117-1.442 4.192 2.044 7.005 5.628.654 7.647-9.48 3.587-13.511-.57-24.693-2.061l-1.856-.097c-.126-5.92-4.971-10.679-10.93-10.679l-.437.009c.685-2.853 1.158-5.8 1.362-8.983l.058-1.07c.028-2.274 2.093-2.838 5.072-4.066l.768-.325Z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#000",
    d: "M36.714 27.17c1.557-.21 2.926-.812 4.006-1.854.44-.423.812-.907 1.116-1.442 4.192 2.044 7.005 5.628.654 7.647-3.001 1.136-5.457 1.495-7.765 1.409 2.107-1.665 2.648-3.771 1.989-5.76Z",
    opacity: 0.3
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#FFF",
    d: "m21.16 4.383-2.015.896c-.2-.096-.425-.15-.663-.15-.847 0-1.534.686-1.534 1.533 0 .846.687 1.532 1.534 1.532.725 0 1.333-.502 1.493-1.177l1.823-.81c.56 1.286 1.22 2.489 1.953 3.611l-1.84 1.295c-.12-.03-.245-.046-.374-.046-.847 0-1.534.686-1.534 1.532 0 .846.687 1.533 1.534 1.533.829 0 1.504-.656 1.534-1.477l.053-.04 1.738-1.224c.85 1.114 1.767 2.138 2.718 3.074l-1.673 1.56c-.076-.012-.154-.018-.233-.018-.847 0-1.534.687-1.534 1.533 0 .846.687 1.532 1.534 1.532.848 0 1.535-.686 1.535-1.532l-.005-.093 1.792-1.672c.923.805 1.862 1.532 2.789 2.184l-1.35 1.563-.07-.001c-.847 0-1.534.686-1.534 1.532 0 .847.687 1.533 1.535 1.533.847 0 1.534-.686 1.534-1.533 0-.086-.007-.17-.02-.253l1.521-1.767c2.376 1.488 4.55 2.466 6.004 2.98l.759.258c-.235.562-.561 1.052-.98 1.456-3.245 3.13-11.404.51-18.024-6.335-4.97-5.141-7.526-11.066-7.116-15.023.986-.527 2.02-1.17 3.076-1.984 2.037-1.123 3.384.21 4.04 3.998Z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#000",
    d: "M33.401 19.033c2.376 1.488 4.55 2.466 6.004 2.98l.759.258c-.235.562-.561 1.052-.98 1.456-.77.742-1.816 1.161-3.052 1.277-.593-2.04-1.503-4.03-2.73-5.971Z",
    opacity: 0.304
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#FFF",
    fillRule: "nonzero",
    d: "m49.99 31.566.01.142c0 4.68-3.8 8.475-8.486 8.475l-40.551 0c-.532 0-.963-.43-.963-.962 0-.53.431-.961.963-.961l40.551 0c3.623 0 6.56-2.934 6.56-6.552 0-.53.431-.961.963-.961.483 0 .884.355.953.82l0 0Z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFigureskating);
export default __webpack_public_path__ + "static/media/figureskating.38b3e673bfb9987c2437694af2b5d2c7.svg";
export { ForwardRef as ReactComponent };